"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxContainer = exports.ListItemName = exports.ListItem = exports.List = exports.ArrowIcon = exports.ArrowContainer = exports.Input = exports.HeaderTitle = exports.HeaderInput = exports.Header = exports.Wrapper = exports.Required = exports.Label = exports.SelectTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const ArrowIcon_1 = require("../../../assets/svg-components/ArrowIcon");
const Typography_1 = __importDefault(require("../../UI/Typography"));
exports.SelectTitle = styled_components_1.default.label `
  margin-right: ${props => props.theme.spacing.s4}px;
  > div {
    margin-bottom: ${props => props.theme.spacing.s1}px;
    color: ${props => ((props === null || props === void 0 ? void 0 : props.labelColor) ? props.labelColor : props.theme.palette.LIGHT_BLACK)};
  }
`;
exports.Label = styled_components_1.default.label `
  display: inline-block;
  cursor: pointer;
  > div {
    color: ${props => props.theme.palette.LIGHT_BLACK};
  }

  ${props => props.required &&
    `> div {
    position: relative;
    :after {
      content: '*';
      color: ${props.theme.palette.UI_WARNING};
      position: absolute;
      top: ${props.theme.spacing.s0}px;
      right: -${props.theme.spacing.s3}px;
    }
  }`}
`;
exports.Required = styled_components_1.default.div `
  display: inline;
  color: ${props => props.theme.palette.RED_100};
  margin-left: ${props => props.theme.spacing.s2}px;
`;
exports.Wrapper = styled_components_1.default.div `
  width: ${props => (props.width && typeof props.width === 'string' ? props.width : `${props.width}px`)};
  position: relative;
  font-size: ${props => props.theme.typography.size.s3}px;
  user-select: none;

  ${props => props.hasLabel &&
    `
    margin-top: ${props.theme.spacing.s1}px;
  `}
`;
exports.Header = styled_components_1.default.button `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  outline: 1px solid ${props => props.disabled
    ? props.theme.palette.LIGHT_GRAY_100
    : props.errorMessage
        ? props.theme.palette.UI_WARNING
        : props.theme.palette.BLUE_GRAY_40};
  border: 1px solid transparent;
  border-radius: ${props => props.theme.constants.borderRadius.xss}px;
  background-color: ${props => (props.disabled ? props.theme.palette.LIGHT_GRAY_30 : props.theme.palette.BW_100)};
  height: ${props => props.theme.constants.SelectDropdownHeight.md}px;
  padding: 0 ${props => props.theme.spacing.s3}px;
    &:focus-visible {
    outline: 2px solid ${props => props.theme.palette.BW_0};
    outline-offset: 2px;
  }
  cursor: pointer;
  ${props => props.isOpen &&
    `outline: ${props.theme.attributes.outlineSize.sm}px solid ${props.theme.palette.ORANGE_40};
  border: 1px solid ${props.theme.palette.ORANGE_100};`}
`;
exports.HeaderInput = styled_components_1.default.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: ${props => props.theme.constants.SelectDropdownHeight.md}px;
`;
exports.HeaderTitle = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
  ${props => props.optionsColor && `color: ${props.optionsColor};`}
  color: ${props => props.disabled && props.theme.palette.BLUE_GRAY_40};
  overflow: hidden;
  white-space: nowrap;
`;
exports.Input = styled_components_1.default.input `
  height: 100%;
  width: 100%;
  margin: 0;
  ${props => props.optionsColor && `color: ${props.optionsColor};`}
  color: ${props => props.disabled && props.theme.palette.BLUE_GRAY_40};
  overflow: hidden;
  white-space: nowrap;
  border: 1px solid ${props => props.disabled ? props.theme.palette.LIGHT_GRAY_100 : props.theme.palette.BLUE_GRAY_40};
  border-radius: ${props => props.theme.constants.borderRadius.xss}px;
  background-color: ${props => (props.disabled ? props.theme.palette.LIGHT_GRAY_30 : props.theme.palette.BW_100)};
  padding-left: ${props => props.theme.spacing.s3}px;
  color: ${props => props.color || props.theme.palette.DARK_GRAY_100};
  font-size: ${props => props.theme.typography.size.defaultSize}px;
  line-height: ${props => props.theme.typography.lineHeight.m2}px;
  font-weight: ${props => props.theme.typography.weight.regular};

  &:focus-visible {
    ${props => !props.error &&
    `
    outline: ${props.theme.attributes.outlineSize.sm}px solid ${props.theme.palette.ORANGE_40};
    border: 1px solid ${props.theme.palette.ORANGE_100};
    `}
  }

  ${props => props.error &&
    `
    outline: ${props.theme.attributes.outlineSize.sm}px solid ${props.theme.palette.RED_20};
    border: 1px solid ${props.theme.palette.UI_WARNING};
  `}
`;
exports.ArrowContainer = styled_components_1.default.button `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.theme.constants.blockWidth.s4}px;
  height: calc(100% - 2px);
  background-color: ${props => props.theme.palette.LIGHT_GRAY_20};
  border: none;
  border-left: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  position: absolute;
  right: 0;
  cursor: pointer;
  margin-right: 1px;
  border-top-right-radius: ${props => props.theme.spacing.s1}px;
  border-bottom-right-radius: ${props => props.theme.spacing.s1}px;
`;
exports.ArrowIcon = (0, styled_components_1.default)(ArrowIcon_1.ArrowIcon) `
  flex-shrink: 0;
  height: ${props => props.theme.constants.SelectDropdownIconHeight.md}px;
  margin-left: ${props => (props.allowInput ? 0 : props.theme.spacing.s4)}px;
  ${props => (props.isOpen ? 'transform: rotate(180deg);' : null)}
  > path {
    stroke: ${props => props.disabled && props.theme.palette.BLUE_GRAY_40};
  }
`;
exports.List = styled_components_1.default.div `
  ${props => !props.isOpen && 'visibility: hidden;'}
  margin-top: ${props => props.theme.spacing.xs}px;
  padding: 0;
  position: absolute;
  z-index: ${props => props.theme.constants.zindex.dropdown};
  ${props => !props.takeContentWidth && 'width: 100%;'}
  ${props => props.isOpen && 'width: 100%;'}
  max-height: ${props => props.theme.constants.SelectDropdownHeight.xxl}px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: ${props => props.theme.spacing.s1}px;
  }
  ::-webkit-scrollbar-track {
    background: ${props => props.theme.palette.LIGHT_GRAY};
    border-radius: ${props => props.theme.spacing.s1}px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.palette.MEDIUM_GRAY};
    border-radius: ${props => props.theme.spacing.s1}px;
  }
  border: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  background-color: white;
  box-shadow: ${props => props.theme.attributes.boxShadow.medium};
  text-align: left;
  -webkit-overflow-scrolling: touch;
`;
exports.ListItem = styled_components_1.default.button `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: none;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s3}px;
  transition: ${props => props.theme.animations.backgroundOnly};
  background-color: ${props => (props.isSelected ? props.theme.palette.BLUE_100 : props.theme.palette.BW_100)};
  &:focus-visible {
    outline: 2px solid ${props => props.theme.palette.ORANGE_40};
    border: 1px solid ${props => props.theme.palette.ORANGE_100};
  }
  &:hover {
    background-color: ${props => (props.isSelected ? props.theme.palette.BLUE_100 : props.theme.palette.BLUE_GRAY_20)};
  }
`;
exports.ListItemName = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
  white-space: normal;
  text-align: start;
  ${props => props.optionsColor && `color: ${props.optionsColor};`}
  ${props => props.isSelected && `color: ${props.theme.palette.BW_100}`};
  ${props => props.disabled && `color: ${props.theme.palette.LIGHT_GRAY_60}`};
`;
exports.CheckboxContainer = styled_components_1.default.div `
  padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s3}px;
  transition: ${props => props.theme.animations.backgroundOnly};

  &:hover {
    ${props => !props.disabled && `background-color: ${props.theme.palette.BLUE_GRAY_20}`};

  }
`;
exports.default = {
    Wrapper: exports.Wrapper,
    Header: exports.Header,
    HeaderTitle: exports.HeaderTitle,
    ArrowIcon: exports.ArrowIcon,
    List: exports.List,
    ListItem: exports.ListItem,
    ListItemName: exports.ListItemName,
    CheckboxContainer: exports.CheckboxContainer,
    Label: exports.Label
};
